/*
 * @Description: 模拟器下载逻辑实现 由于之前很恶心的逻辑 需要处理2个接口3个监听 😢
 * @Author: kadenwang@tencent.com
 * @Date: 2020-06-18 17:27:57
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2021-10-29 10:40:53
 */

import {
  AppInfo, AppDownloadStage, AppDownloadStateCallback, AppDownloadState, StartAppDownloadReq,
  StopAppDownloadReq, InstallDownloadedAppReq, LaunchAppReq, AppVersionCollection,
} from '@tencent/halo-jsbridge';

import { Market, tgbEventBus, GameMan19 } from './core/index';
import { getInstallState, getGameState, State } from './core/gameState';

/**
 * 把各种恶心的状态码转成标准的状态码
 */

export type ITransformtype = 'GetInstalledList' | 'InstallControl_New' | 'EngineProgress' | 'GetGameInstallList';

export interface IcacheData {
  cb?: AppDownloadStateCallback;
}

/*
  Market.PkgStateChange 是状态变化
  Market.PkgInstallProgress 是状态扭转的进度
*/

tgbEventBus.$on('Market.PkgStateChange', (info) => {
  console.info(`Market.PkgStateChange------ ${JSON.stringify(info)}`);
  if (cacheData[info.pkgName] && cacheData[info.pkgName].key === info.pkgName) {
    const { state, raw } = transformState(info, 'InstallControl_New');
    cacheData[info.pkgName].key = info.pkgName;
    cacheData[info.pkgName].state = state;
    cacheData[info.pkgName].raw = { ...cacheData[info.pkgName].raw, ...raw };

    cacheData[info.pkgName].cb(cacheData[info.pkgName]);
  }
});

tgbEventBus.$on('Market.PkgInstallProgress', (info) => {
  console.info(`Market.PkgInstallProgress----- ${JSON.stringify(info)}`);
  if (cacheData[info.pkgName] && cacheData[info.pkgName].key === info.pkgName) {
    const { state } = transformState(info, 'InstallControl_New');
    cacheData[info.pkgName].key = info.pkgName;
    cacheData[info.pkgName].progress = Number(((info.downloadedSize / info.totalSize) * 1000)
      .toFixed(1));

    cacheData[info.pkgName].state = state;
    cacheData[info.pkgName].raw = { ...cacheData[info.pkgName].raw, ...info };

    cacheData[info.pkgName].cb(cacheData[info.pkgName]);
  }
});

tgbEventBus.$on('Market.EngineProgress', (info) => {
  console.info(`Market.EngineProgress----- ${JSON.stringify(info)}`);
  if (cacheData[info.pkgName] && cacheData[info.pkgName].key === info.pkgName) {
    const { state, raw } = transformState(info, 'EngineProgress');
    cacheData[info.pkgName].key = info.pkgName;
    if (info.status === 5 || info.status === 2) {
      cacheData[info.pkgName].progress = Number(((info.downloadedSize / info.totalSize) * 1000)
        .toFixed(1));
    } else {
      // 老客户端安装完成、下载完成进度错误、这里删掉
      delete raw.downloadedSize;
      delete raw.totalSize;
    }

    cacheData[info.pkgName].state = state;
    cacheData[info.pkgName].raw = { ...cacheData[info.pkgName].raw, ...raw };

    cacheData[info.pkgName].cb(cacheData[info.pkgName]);

    // if (info.status !== 3) {
    //   /** 引擎下载完成没必要区分是那个安装完了 不用回调 */
    //   cacheData[info.pkgName].cb(cacheData[info.pkgName]);
    // }
  }
});

tgbEventBus.$on('GameMan19.GameInstallItemUpdate', (info) => {
  console.info(`GameMan19.GameInstallItemUpdate----- ${JSON.stringify(info.game)}`);
  if (cacheData[info.game.id] && cacheData[info.game.id].key === info.game.id) {
    const { state, raw } = transformState(info.game, 'InstallControl_New');
    cacheData[info.game.id].key = info.game.id;
    cacheData[info.game.id].progress = parseFloat(info.game.downloaderProgress.toFixed(3)) * 1000;

    cacheData[info.game.id].state = state;
    cacheData[info.game.id].raw = { ...cacheData[info.game.id].raw, ...raw };

    cacheData[info.game.id].cb(cacheData[info.game.id]);
  }
});

const cacheData: IcacheData = {};

export interface IRaw {
  rawState: State;
  /** 地区 */
  area?: string;
  /** 下载速度 */
  downloadSpeed?: number;
  /** 已经下载的大小 */
  downloadedSize?: string;
  /** gameId */
  gameId?: string;
  /** 下载进度 */
  percent?: number;
  /** 包名 */
  pkgName?: string;
  /** 总大小 */
  totalSize?: string;
  /** 还有可能是透穿的字端 */
  req?: any;
}

type IdefaultData = AppDownloadState & { raw: IRaw };

const defaultData: IdefaultData = {
  key: '',
  state: AppDownloadStage.ready,
  progress: 0,
  raw: {
    rawState: State.init,
  },
};

export interface ItransformState {
  /* 给 halo-downloader 用的字端 */
  state: AppDownloadStage;
  raw: {
    /* 自己用的字端 */
    rawState: State;
    [props: string]: any;
  };
}

function transformState(params, type: ITransformtype): ItransformState {
  let standardCode: State = State.init;
  let state: AppDownloadStage = AppDownloadStage.ready;

  switch (type) {
    case 'GetInstalledList':
      standardCode = getGameState(params);
      break;
    case 'InstallControl_New':
      standardCode = getInstallState(params);
      break;
    case 'EngineProgress': {
      const engineState = params && params.status;
      switch (engineState) {
        case 1:
          standardCode = State.EngineStart;
          break;
        case 2:
          standardCode = State.EngineInstalling;
          break;
        case 3:
          standardCode = State.EngineFinish;
          break;
        case 4:
          standardCode = State.EngineError;
          break;
        case 5:
          standardCode = State.EngineDownLoading;
          break;
        case 6:
          standardCode = State.EngineDownloadPause;
          break;
        case 7:
          standardCode = State.EngineDownloadFinish;
          break;
        default:
          break;
      }

      params.downloadSpeed = params.speed;
    }

      break;
    case 'GetGameInstallList': {
      standardCode = getGameState(params);
      params.downloadSpeed = params.speed || 0;
      break;
    }

    default:
      break;
  }

  switch (standardCode) {
    case State.WaitForDownload:
      state = AppDownloadStage.pending;
      break;
    case State.EngineDownLoading:
    case State.Downloading:
      state = AppDownloadStage.downloading;
      break;
    case State.DownloadPause:
    case State.EngineDownloadPause:
      state = AppDownloadStage.paused;
      break;
    case State.EndDownload:
      state = AppDownloadStage.downloaded;
      break;
    case State.Installed:
      state = AppDownloadStage.installed;
      break;
    case State.Installing:
      state = AppDownloadStage.installing;
      break;
    case State.EngineError:
    case State.DownloadFailed:
    case State.LocalInstallPathError:
      state = AppDownloadStage.error;
      break;
    default:
      break;
  }

  return {
    state,
    raw: {
      rawState: standardCode,
      ...params,
    },
  };
}

/**
 * 获取当前媒体端将某个应用信息用于做下载任务去重时的唯一标识
 *
 * @description
 * 有一些媒体端会对应用下载任务进行去重，同一款应用不会重复下载。
 * 本函数输入应用信息，返回对应的哈希值，从而模拟当前媒体端的下载任务去重规则
 */
export function getAppInfoKey(appInfo: AppInfo): string {
  return String(appInfo?.packageName ?? '');
}

/**
 * 注册应用下载状态变更回调
 * @description 多次调用将会按调用顺序依次执行
 */
export function registerStateCallback(key: string | null, cb: AppDownloadStateCallback): void {
  /*
    Market.PkgStateChange 是状态变化
    Market.PkgInstallProgress 是状态扭转的进度
  */
  if (!key) {
    console.error('call registerStateCallback with no key!');
    return;
  }

  if (!(cacheData[key])) {
    cacheData[key] = JSON.parse(JSON.stringify(defaultData));
  }

  if (!cacheData[key].cb) {
    cacheData[key].cb = cb;
  } else {
    console.info(`${key} pkgname has been registered`);
  }
}

/** 查询应用的下载状态 */
export async function queryAppDownload(req: AppInfo): Promise<AppDownloadState> {
  const result = await Market.GetInstalledList(false) || [];

  if (!cacheData[req.packageName].key) {
    // 如果没有证明是第一次初始化 需要查 GetInstalledList 或者 GetGameInstallList
    let filteredData;
    if (req.isPcGame) {
      const pcGameResult = await GameMan19.GetGameInstallList() || [];
      // eslint-disable-next-line prefer-destructuring
      filteredData = pcGameResult.filter((game) => game.id === req.packageName)[0];
    } else {
      // eslint-disable-next-line prefer-destructuring
      filteredData = result.filter((game) => game.game_id === req.packageName)[0];
    }

    if (filteredData) {
      const { state, raw } = transformState(filteredData, req.isPcGame ? 'GetGameInstallList' : 'GetInstalledList');

      cacheData[req.packageName].state = state;
      cacheData[req.packageName].progress = req.isPcGame
        ? parseFloat(filteredData.downloaderProgress.toFixed(3)) * 1000
        : Math.floor(filteredData.percent ?? 0 / 10);

      cacheData[req.packageName].raw = raw;
    }
  }

  /** 这里才会给 key 赋值 */
  cacheData[req.packageName].key = req.packageName;
  // 把请求体通过 raw 传回去
  cacheData[req.packageName].raw.req = req;

  return Promise.resolve(cacheData[req.packageName]);
}

/**
 * 开始下载应用
 * @description 创建下载任务并开始下载，或是继续已经暂停的下载
 */
export async function startAppDownload(req: StartAppDownloadReq): Promise<void> {
  const { raw } = cacheData[req.packageName];
  const { rawState } = raw;
  const { isLocalInstall = false, localApkPath = '', size, packageName, autoDownLoadArea, pcGameJson, isPreDownloadItem = false, itemType } = req;

  // 开始下载之后这个 queryAppDownload 就失效了，需要拿一下最新的状态
  switch (rawState) {
    case State.init:
    case State.DownloadFailed:
    case State.EngineError:
      /* 未下载 -> 触发下载 */
      Market.beginInstallNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
    case State.Downloading:
    case State.EngineDownLoading:
    case State.WaitForDownload:
      /* 下载中 -> 暂停下载 */
      Market.pauseInstallNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
    case State.DownloadPause:
    case State.EngineDownloadPause:
      /* 暂停中 -> 恢复下载 */
      Market.continueInstallNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
    case State.Installed:
      /* 安装完成 -> 打开 */
      launchApp(req);
      break;
    case State.CanUpgrade:
      /* 可升级 -> 升级 */
      if (req.isPcGame) return;

      Market.updatePackageNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
    case State.CanInstall:
      /* 可安装 -> 安装 */
      Market.beginInstallNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
    default:
      /* 未捕获的状态 */
      Market.beginInstallNew({
        id: packageName,
        adtag: '',
        updateJson: '',
        preload: false,
        isLocalInstall,
        packageSize: size,
        localApkPath,
        area: autoDownLoadArea,
        pcGameJson,
        isPreDownloadItem,
        itemType,
      });

      break;
  }
}

/**
 * 停止下载应用
 * @description 根据媒体端的不同, 有可能是暂停下载或是取消下载
 */
export function stopAppDownload(req: StopAppDownloadReq): Promise<void> {
  const { isLocalInstall = false, localApkPath = '', size, packageName, autoDownLoadArea, pcGameJson, isPreDownloadItem = false, itemType } = req;

  Market.pauseInstallNew({
    id: packageName,
    adtag: '',
    updateJson: '',
    preload: false,
    isLocalInstall,
    packageSize: size,
    localApkPath,
    area: autoDownLoadArea,
    pcGameJson,
    isPreDownloadItem,
    itemType,
  });

  return Promise.resolve();
}

/** 安装已经下载完成的应用 */
export function installDownloadedApp(req: InstallDownloadedAppReq): Promise<void> {
  /** 模拟器下载完成会自动安装应用的 */
  const { isLocalInstall = false, localApkPath = '', size, packageName, autoDownLoadArea, pcGameJson, isPreDownloadItem = false, itemType } = req;

  Market.beginInstallNew({
    id: packageName,
    adtag: '',
    updateJson: '',
    preload: false,
    isLocalInstall,
    packageSize: size,
    localApkPath,
    area: autoDownLoadArea,
    pcGameJson,
    isPreDownloadItem,
    itemType,
  });

  return Promise.resolve();
}

/** 打开应用 */
export function launchApp(req: LaunchAppReq): Promise<void> {
  if (req.isPcGame) {
    GameMan19.LaunchGame(req.packageName);
  } else {
    Market.launchPackage(req.packageName, '', undefined, req.isGoogleAd);
  }

  return Promise.resolve();
}

/** 获取一个或多个应用已安装的版本号 */
export function queryAppVersion(apps: AppInfo | AppInfo[]): Promise<AppVersionCollection> {
  /** 看起来对模拟器没什么用 */
  if (Array.isArray(apps)) {
    throw new Error('暂时不支持传多个');
  }

  return Market.getVersion(apps.packageName);
}

/** 删除应用 */
export function deletePackage(req: LaunchAppReq): Promise<void> {
  if (req.isPcGame) {
    GameMan19.RemoveGame(req.packageName);
  } else {
    Market.deletePackage(req.packageName, '', req.itemType, req.isGoogleAd);
  }

  return Promise.resolve();
}

/** 取消下载 */
export function cancelInstall(req: StopAppDownloadReq): Promise<void> {
  const { isLocalInstall = false, localApkPath = '', size, packageName, autoDownLoadArea, pcGameJson, isPreDownloadItem = false, itemType } = req;

  Market.cancelInstallNew({
    id: packageName,
    adtag: '',
    updateJson: '',
    preload: false,
    isLocalInstall,
    packageSize: size,
    localApkPath,
    area: autoDownLoadArea,
    pcGameJson,
    isPreDownloadItem,
    itemType,
  });

  return Promise.resolve();
}
